import { OrgView } from "../components/Org";
import { useOrgParams, usePermissions } from "../hooks";
import { UnauthorizedMessage } from "../../shared/components";
import { OrgDeprovisionAction } from "../components/OrgSettings/OrgDeprovisionAction";
import { OrgNameForm } from "../components/OrgSettings/OrgNameForm";

export function OrgSettingsScreen() {
  const { id } = useOrgParams();
  const { isAdminOfOrg, isProvisioner } = usePermissions();

  // Only admins or provisioners can access this page
  if (!isAdminOfOrg(id)) {
    return <UnauthorizedMessage />;
  }

  return (
    <OrgView title="Settings">
      {(org) => (
        <>
          {/* Admin can change the organization name */}
          {isAdminOfOrg(id) && (
            <OrgNameForm category={org.category} id={org.id} name={org.name} />
          )}

          {/* Only provisioners can deprovision an organization */}
          {isProvisioner() && <OrgDeprovisionAction org={org} />}
        </>
      )}
    </OrgView>
  );
}
